import vueInstance from '../main'
import { times } from 'number-precision'

export const getRenderText = (key) => {
  return vueInstance.$t(key)
}

// 英里转千米
export const milesTOKilometers = (value) => {
  const factor = 1.60934
  return times(value, factor)
}

/** 兼容 JSON 字符串与已解析的对象/数组 */
export function parseJsonValue(value, defaultValue = null) {
  if (value == null || value === '') return defaultValue
  if (typeof value === 'object') return value
  if (typeof value === 'string') {
    try {
      return JSON.parse(value)
    } catch (error) {
      return defaultValue
    }
  }
  return defaultValue
}

export function parseJsonArray(value, defaultValue = []) {
  const parsed = parseJsonValue(value, defaultValue)
  return Array.isArray(parsed) ? parsed : defaultValue
}

export function parseJsonObject(value, defaultValue = {}) {
  const parsed = parseJsonValue(value, defaultValue)
  return parsed && typeof parsed === 'object' && !Array.isArray(parsed) ? parsed : defaultValue
}
